import { render, staticRenderFns } from "./RadarChart.vue?vue&type=template&id=55665e7a&scoped=true&"
import script from "./RadarChart.vue?vue&type=script&lang=js&"
export * from "./RadarChart.vue?vue&type=script&lang=js&"
import style0 from "./RadarChart.vue?vue&type=style&index=0&id=55665e7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55665e7a",
  null
  
)

export default component.exports